<template>
  <div class="customer-baseinfo">
    <h3>企业账户管理</h3>
    <div class="edit-btns">
      <a-button
        slot="extra"
        type="primary"
        size="default"
        @click="editBasic"
        class="margin-bottom-20"
        v-if="permissions && permissions.includes('编辑')"
      >
        编辑
      </a-button>
    </div>
    <CardEdit
      ref="formAddress"
      :source-data="sourceDataBasic"
      :schema="ACCOUNT_SCHEMA"
      layout="horizontal"
      :labelCol="labelCol"
      :wrapperCol="wrapperCol"
    >
      <template v-slot:operate-area>
        <div v-show="basicButtonsShow" style="text-align:right">
          <a-button type="" @click="handleCancelBasic">
            取消
          </a-button>
          <a-button
            type="primary"
            class="margin-left-20"
            @click="handleSubmitBasic"
          >
            保存
          </a-button>
        </div>
      </template>
    </CardEdit>
  </div>
</template>
<script>
import { CardEdit } from 'lxfintech-fe'
//import ExtraInfo from './ExtraInfo'
import { SCORE_CARD_SCHEMA } from '@/utils/staticData.js'
import mixin from './mixinAccount'
import { addAccount, getrisk } from '../api'
import areaList from '@/utils/area.json'
export default {
  components: {
    CardEdit,
  },
  mixins: [mixin],
  name: 'create-form',
  props: ['permissions', 'customerDetail'],
  data() {
    return {
      visible: false,
      confirmLoading: false,
      MODAL_WIDTH: 1000,
      SCORE_CARD_SCHEMA,
      formLayout: 'horizontal',
      checkboxList: [],
      filters: [],
      destroyOnClose: true,
      activeKey: [1, 2],
      basicButtonsShow: false, //企业基本信息按钮是否展现
      businessList: [], //业务类型
      regionOptionList: [], //大区/模式 optionList
      optionsArea: [],
      fieldNames: {
        label: 'title',
        value: 'title',
        children: 'data',
      },
      defaultValue: [],
      pids: [],
    }
  },
  computed: {
    // 信用主管默认选择当前用户
  },
  created() {
    this.optionsArea = areaList.title
  },
  mounted() {
    this._getrisk()
    setTimeout(() => {
      this.query()
    }, 1000)
  },
  methods: {
    // 获取风险标签下拉框
    async _getrisk() {
      const { data } = await getrisk()
      this.riskList = data.map(item => ({
        label: item.name,
        value: item.id,
      }))
      this.ACCOUNT_SCHEMA.riskLabels.optionList = this.riskList
    }, // 企业地址信息
    query() {
      for (let key in this.sourceDataBasic) {
        if (key === 'companyCode') {
          this.sourceDataBasic[key] = this.customerDetail.base.code
        } else {
          this.sourceDataBasic[key] = this.customerDetail.account[key]
          this.sourceDataBasic['riskLabels'] = this.customerDetail.account[
            'riskLabels'
          ].map(item => item.id)
        }
      }
    }, //编辑-企业基本信息
    editBasic() {
      this.basicButtonsShow = true
      for (let key in this.ACCOUNT_SCHEMA) {
        this.ACCOUNT_SCHEMA[key].disabled = false
      }
    }, // 校验 - 企业基本信息
    async validateForm() {
      try {
        var values = await this.$refs.formAddress.handleSubmit()
        const passed = !!values
        if (passed) {
          for (let key in this.sourceDataBasic) {
            if (key != 'companyCode' && key != 'riskLabels') {
              this.sourceDataBasic[key] = values[key]
            }
            if (key == 'riskLabels') {
              const arr = []
              this.riskList.map(item => {
                if (values[key].indexOf(item.value) !== -1) {
                  const obj = {}
                  obj.name = item.label
                  obj.id = item.value
                  arr.push(obj)
                }
              })
              this.sourceDataBasic[key] = arr
            }
          }
          return this.sourceDataBasic
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 保存 - 企业基本信息
    async handleSubmitBasic() {
      var data = await this.validateForm()
      if (data) {
        addAccount(data).then(() => {
          this.$message.success('成功')
          this.basicButtonsShow = false
          // disabled
          for (let key in this.ACCOUNT_SCHEMA) {
            this.ACCOUNT_SCHEMA[key].disabled = true
          }
        })
      }
    },
    // 取消 - 企业基本信息
    handleCancelBasic() {
      this.$refs.formAddress.handleReset()
      this.basicButtonsShow = false
      //disabled
      for (let key in this.ACCOUNT_SCHEMA) {
        this.ACCOUNT_SCHEMA[key].disabled = true
      }
    },
  },
}
</script>
<style lang="less" scoped>
.customer-baseinfo {
  .margin-left-20 {
    margin-left: 20px;
  }
  .client-center-home
    /deep/
    .ant-collapse
    > .ant-collapse-item
    > .ant-collapse-header {
    line-height: 30px;
  }
  .edit-btns {
    text-align: right;
    width: 98.5%;
  }
  .margin-bottom-20 {
    margin-bottom: 20px;
  }
}
</style>
